import { make as makeSimpleDate } from 'foundations-components/transitional/utils/SimpleDate';
const formatDateString = date => {
  if (date < 10) {
    return `0${date}`;
  }
  return date;
};
export const formatDate = (date, useHyphen = false) => {
  const components = [date.year, formatDateString(date.month + 1), formatDateString(date.date)];
  return components.join(useHyphen ? '-' : '');
};

/**
 * Converts a date string to a SimpleDate object
 * @param date string, date represented in the format *"YYYYMMDD"*
 * @returns SimpleDate object
 */
export const toSimpleDate = date => makeSimpleDate(parseInt(date.substring(0, 4), 10), parseInt(date.substring(4, 6), 10) - 1,
// moment starts month at 0
parseInt(date.substring(6), 10));
export const extractCompleteDateRange = dateRange => {
  if (dateRange && dateRange.endDate && dateRange.startDate) {
    return {
      startDateInt: parseInt(formatDate(dateRange.startDate, false), 10),
      endDateInt: parseInt(formatDate(dateRange.endDate, false), 10)
    };
  }
  return undefined;
};